import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import 'store/bolt/dynamicData';
import { transformPageData } from 'utils/bolt/dynamicData';
import { getDynamicData } from 'utils/bolt/dynamicData';
import parseQueryString from 'utils/parseQueryString';
// import pure from 'utils/pure';
import Store from 'store/store';
// import * as tracking from 'store/bolt/trackingV2';
import 'store/bolt';
import 'store/bolt/calendarRemind';
import 'store/bolt/cookies';
import 'store/bolt/ageGate';
import 'store/bolt/pixels';
import 'store/bolt/externalCookieBanner';
import 'store/bolt/subscriberPopup';
import 'store/bolt/trailerOverlay';
import 'utils/bolt/markdownSetUp';
import { navigateInternally } from 'utils/bolt/index';
import * as categories from 'utils/gdpr/categories';


const isServer = typeof window === 'undefined';
if (!isServer) {
	window.navigateInternally = navigateInternally;
	window.powCategories = categories;
}

export default class BoltApp extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount();
		const { previewDataPath } = parseQueryString();
		await this.loadEventsPages(previewDataPath);
		this.setState({ dynamicDataUpdated: true });
	}

	async loadEventsPages(previewDataPath) {
		const data = await getDynamicData('event-album');
		// console.log('event-album dynamic data:', data);
		const pages = Object.values(data || {}).flatMap(transformPageData);
		Store.get().appData.pages.set(Object.fromEntries(pages.map(p => [p.id, p]))).now();
		const desiredPage = data[previewDataPath]?.url;
		if (desiredPage) {
			navigateInternally(desiredPage);
		}
	}

	constructor(props) {
		super(props);

		Store.on('CHANGE_YOUTUBE_VIDEO', (youtubeId) => {
			this.showFinalTrailer(youtubeId); 
		});

	}

	showFinalTrailer(id) {
		// console.log('show final trailer');
		const youtubeId = id || 'em_k6jGdw-0' || {}; 
		Store.emit('ENABLE_TRAILER_OVERLAY', {
			video: {
				name: 'trailer',
				noCookies: false,
				order: 1,
				publishedAt: '2024-09-17',
				thumbSrc: `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
				youtubeId
			}
		});
	}
}